import { Obj, Str } from '@livecontrol/core-utils';
import { Errors } from '@livecontrol/scheduler/store';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { store } from '../factory';
import type { Draft } from '../types';

interface TVariables {
  email: string;
}

type Args = TVariables;

export const useForgotPassword = (): [
  (args: Args) => void,
  {
    error?: Error;
    loading: boolean;
  }
] => {
  const history = useHistory();
  const { environment } = store.getState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();

  return [
    useCallback(
      (args: Args): void => {
        try {
          // Parse the input arguments
          const variables = {
            Username: Str.normalize(args.email)
          };

          // Validate the input
          if (!Obj.isHydrated(variables)) {
            throw Errors.badRequest();
          }

          setLoading(true);

          const poolData = {
            UserPoolId: environment.COGNITO_POOL_ID,
            ClientId: environment.COGNITO_APP_CLIENT_ID
          };

          const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

          const userData = {
            ...variables,
            Pool: userPool
          };

          const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

          const callbacks = {
            onSuccess: (): void => {
              setLoading(false);
            },
            inputVerificationCode: (): void => {
              store.produce((draft: Draft) => {
                draft.awsCognitoUser = cognitoUser;
              });

              setLoading(false);
              history.push('/forgot-password-confirmation');
            },
            onFailure: (err: unknown): void => {
              setError(<Error>err);
              setLoading(false);
            }
          };

          cognitoUser.forgotPassword(callbacks);
        } catch (error_: unknown) {
          setError(<Error>error_);
          setLoading(false);
        }
      },
      [environment, history]
    ),
    {
      error,
      loading
    }
  ];
};
